import { render, staticRenderFns } from "./SupportTicketDetail.vue?vue&type=template&id=16d1740d&scoped=true"
import script from "./SupportTicketDetail.vue?vue&type=script&lang=js"
export * from "./SupportTicketDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketDetail.vue?vue&type=style&index=0&id=16d1740d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1740d",
  null
  
)

export default component.exports